
export const putInto = (obj, path, val) => {
  if (typeof path === 'string') {
    const [, ...parts] = path.split('.');
    return putInto(obj, parts, val);
  }

  if (path.length === 0) return val;
  const [name, ...rest] = path;
  if (isNaN(Number(name))) {
    obj = obj && typeof obj === 'object' ? obj : {};
    return {
      ...obj,
      [name]: putInto(obj[name], rest, val),
    };
  } else {
    obj = Array.isArray(obj) ? [...obj] : [];
    obj[Number(name)] = putInto(obj[Number(name)], rest, val);
    return obj;
  }
};

export const hasAnyError = (errors) => {
  if (errors && typeof errors === 'object') return Object.values(errors).some(val => hasAnyError(val));
  return Boolean(errors);
};

export const touchAllErrors = (errors) => {
  if (typeof errors !== 'object' || errors === null) return Boolean(errors);
  if (Array.isArray(errors)) return [...errors.map(e => touchAllErrors(e))];
  return Object.keys(errors)
    .reduce(
      (acc, key) => Object.assign(acc, { [key]: touchAllErrors(errors[key]) }),
      {}
    );
};
